module.exports = __webpack_public_path__ + "static/media/ENCONTRO_1_ED_FISICA.1ddea75b.pdf";